module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"months":"months | {count} month | {count} months","text":"Changes will affect your next payment","nextPayment":"Next payment","total":"Total ","save":"Save","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
